<div class="settings-panel" [ngClass]="{
       'settings-panel_collapsed': isCollapsedPanel
     }">
    <button class="settings-panel__collapse-toggle" aria-label="Expand/collapse settings panel"
        (click)="panelColapseToggle()">
        <span
            class="dds-icon {{isCollapsedPanel ? 'dds-icon_expand__s__stroke' : 'dds-icon_collapse__s__stroke'}}"></span>
    </button>

    <div class="settings-panel__content">
        <div class="settings-panel__info">
            <span class="dds-icon dds-icon_info settings-panel__icon-info"></span>

            This panel allows you to customize an application interface build on DDS by changing color themes, component
            sizes, header and left panel.
        </div>

        <div class="settings-panel__controls">
            <!-- Themes -->
            <dds-select label="Theme" labelPosition="external" [value]="selectedItem" size="md" [list]="themesList"
                [optionsTemplate]="optionsTemp" class="settings-panel__control-item settings-panel__control-item_select"
                (valueChanged)="selectTheme($event)">
            </dds-select>

            <ng-template #optionsTemp let-ctx="ctx">
                <dds-context-menu>
                    @for (item of ctx.list; track item) {
                    <dds-context-menu-item (selectedItem)="ctx.changeItem(item)">
                        <div class="circle" [ngStyle]="{'background': getCircleColor(item.colors)}"></div>
                        {{item.heading}}
                    </dds-context-menu-item>
                    }
                </dds-context-menu>
            </ng-template>
            <!-- Component size -->
            <div class="settings-panel__control-item">
                <span class="settings-panel__control-label">Component size</span>

                <dds-segmented-control theme="dark" width="full" size="md" [value]="size"
                    (segmentChanged)="sizeChanged($event)">

                    @for (item of sizesList; track item) {
                    <dds-segmented-control-item [heading]="item.heading"
                        [value]="item.value"></dds-segmented-control-item>
                    }

                </dds-segmented-control>
            </div>

            <!-- Menu mode -->
            <div class="settings-panel__control-item settings-panel__control-item_segmented-icon">
                <span class="settings-panel__control-label">Menu mode</span>

                <dds-segmented-control theme="dark" type="icon" size="md" [value]="menuModeValue"
                    (segmentChanged)="menuModeChanged($event)">

                    @for (item of menuMode; track item) {
                    <dds-segmented-control-item [icon]="item.icon" [value]="item.value" [ariaLabel]="item.ariaLabel"
                        maxWidth="36px"></dds-segmented-control-item>
                    }

                </dds-segmented-control>
            </div>

            <!-- Header mode  -->
            <div class="settings-panel__control-item settings-panel__control-item_segmented-icon">
                <span class="settings-panel__control-label">Header mode</span>

                <dds-segmented-control theme="dark" type="icon" size="md" [value]="headerModeValue"
                    (segmentChanged)="headerModeChanged($event)">

                    @for (item of headerMode; track item) {
                    <dds-segmented-control-item [icon]="item.icon" [value]="item.value" [ariaLabel]="item.ariaLabel"
                        maxWidth="36px"></dds-segmented-control-item>
                    }

                </dds-segmented-control>
            </div>

        </div>
    </div>

</div>